import { Controller } from '@hotwired/stimulus'

// Keeps the OS app-icon badge in sync with the unviewed notification count.
//
// The service worker sets the badge when a push arrives, but only the running
// page knows when the user has actually viewed notifications. This controller
// is attached to the count partial, which re-renders on every navigation and on
// the Turbo Stream broadcast, so it clears (or updates) the badge accordingly.
//
//   <div data-controller="app-badge" data-app-badge-count-value="<%= count %>">
export default class extends Controller {
  static values = { count: Number }

  connect () {
    this.sync()
  }

  countValueChanged () {
    this.sync()
  }

  sync () {
    if (this.countValue > 0) {
      if (navigator.setAppBadge) navigator.setAppBadge(this.countValue)
    } else {
      if (navigator.clearAppBadge) navigator.clearAppBadge()
    }
  }
}
